import type { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import internalTeam from '@/data/internalTeam.ts';
import type { RootState } from '@/store';
import { set } from '@/store/Opportunity/Vendor';

export default function Vendor() {
  const dispatch = useDispatch();
  const vendorState = useSelector((state: RootState) => state.opportunity.vendor);

  const changeHandler = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
    dispatch(set({ [e.target.name]: e.target.value }));
  };

  return (
    <>
      <h2 className='mt-0 text-primaryColor-normal'>Vendor</h2>
      <div className='relative mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          {' '}
          Architect <sup>*</sup>
        </label>
        <select className='form-input px-2 py-2 appearance-none' name='architect' value={vendorState.architect} onChange={changeHandler}>
          <option value='' disabled selected>
            Select Architect
          </option>
          {internalTeam.map((s, index) => (
            <option key={index} value={s.Employee_Name}>
              {s.Employee_Name}
            </option>
          ))}
        </select>
      </div>

      <div className='relative mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          {' '}
          General Contractor <sup>*</sup>
        </label>

        <select
          className='form-input px-2 py-2 appearance-none'
          name='generalContractor'
          value={vendorState.generalContractor}
          onChange={changeHandler}
        >
          <option value='' disabled selected>
            Select General Contractor
          </option>
          {internalTeam.map((s, index) => (
            <option key={index} value={s.Employee_Name}>
              {s.Employee_Name}
            </option>
          ))}
        </select>
      </div>

      <div className='relative mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          {' '}
          Civil Engineer <sup>*</sup>
        </label>

        <select
          className='form-input px-2 py-2 appearance-none'
          name='civilEngineer'
          value={vendorState.civilEngineer}
          onChange={changeHandler}
        >
          <option value='' disabled selected>
            Select Civil Engineer
          </option>
          {internalTeam.map((s, index) => (
            <option key={index} value={s.Employee_Name}>
              {s.Employee_Name}
            </option>
          ))}
        </select>
      </div>

      <div className='relative mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          {' '}
          Structural Engineer<sup>*</sup>
        </label>

        <select
          className='form-input px-2 py-2 appearance-none'
          name='structuralEngineer'
          value={vendorState.structuralEngineer}
          onChange={changeHandler}
        >
          <option value='' disabled selected>
            Select Structural Engineer
          </option>
          {internalTeam.map((s, index) => (
            <option key={index} value={s.Employee_Name}>
              {s.Employee_Name}
            </option>
          ))}
        </select>
      </div>

      <div className='relative mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          {' '}
          other<sup>*</sup>
        </label>
        <input type='text' name='other' value={vendorState.other} className='form-input' onChange={changeHandler} />
      </div>
    </>
  );
}
